module.exports = __webpack_public_path__ + "assets/img/组 527@2x.2353c46c.png";